const api = {
     genericList(url, filter = null) {
        if (filter) {
            let paramsString = '?';
            for (const prop in filter) {
                if (prop) {
                    paramsString += encodeURIComponent(prop) + '=' + encodeURIComponent(filter[prop]) + '&';
                }
            }
            url += paramsString.substr(0, paramsString.length - 1);
        }
        return new Promise((resolve, reject) => {
            this.apiClient()
                .get(`${url}`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
    genericGet(url, params = null) {
        return new Promise((resolve, reject) => {
            this.apiClient()
                .get(url, { params: params })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
    genericDetail(url, pk, finalSlash = true, filter = null) {
        url = url + pk + (finalSlash ? '/' : '');
        if (filter) {
            url += '?' + Object.keys(filter).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(filter[k])}`).join('&');
        }
        return new Promise((resolve, reject) => {
            this.apiClient()
                .get(url)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
    genericPost(url, data) {
        return new Promise((resolve, reject) => {
            this.apiClient()
                .post(`${url}`, data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
};

export default api;



// WEBPACK FOOTER //
// ./src/generic.js